import swal from "sweetalert2";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CONSTANTS from "@/store/constants";
import filter from "@/filters/filter";
import PaymentsFormMixin from "@/mixins/PaymentFormsMixin";
import api from "../api";

export default {
	data(){
		return{
			isFastTrackEligible : false,
			isAribaEligible : false,
			companyBuyingServicesCombined : [],
			countryListOptions: null,
			oneIntakeCheckBoxCountries: null,
			isIndependentContractor: false,
			supplierCountry: null,
			independentContractorRedirectLink:{
				"US":CONSTANTS.PROCUREMENT_DOCUMENT_IC_URL_US,
				"Canada":CONSTANTS.PROCUREMENT_DOCUMENT_IC_URL_CANADA,
				"UK":CONSTANTS.PROCUREMENT_DOCUMENT_IC_URL_UK
			}
		}
	},
	mixins: [PaymentsFormMixin],
	watch: {
		adminDataList(val) {
			if (val) {
				this.filterCountryOptions();
			}
		}
	},
	created: function() {
		this.initializeCountryData();
	},
	computed: {
		...mapGetters([
			"caseDetails",
			"supplierOnboardRequestData",
			"currentUser",
			"adskContactInfo",
			"draftId",
			"errorMessage",
			"draftId",
			"tabItems",
			"watchers",
			"errorDetail",
			"supplierCountryList"
		]),
		isCountryUS(){
			if (Array.isArray(this.supplierOnboardRequestData.companyBuyingServiceCheckBox) &&  this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length > 0 ){
				return this.supplierOnboardRequestData.companyBuyingServiceCheckBox.some((companyObj)=> companyObj.country === "US")
			} else return this.supplierOnboardRequestData.companyBuyingServices.includes("United States (US) - Autodesk Inc - 3000");
		},
		isAcquiringThirdPartyTech(){
			//This property helps to toggle Q15a to Q15e being hidden/shown.
			return this.supplierOnboardRequestData.thirdPartyLicenseRequired === true;
		},
		isProcurementCategoryTechnology(){
			return this.supplierOnboardRequestData.category === CONSTANTS.PROCUREMENT_TECHNOLOGY_OPTION
		},
		isArtificialIntelligenceOrMachineLearning(){
			//This property helps to toggle Q15a to Q15e being hidden/shown.
			return this.supplierOnboardRequestData.artificialIntelligenceOrMachineLearning === true;
		},
		isGenerativeAI(){
			return this.supplierOnboardRequestData.generativeAI === 'yes';
		},
		isSOWRequest(){
			return CONSTANTS.SUPPLIER_REQUIRES_SOW.includes(this.supplierOnboardRequestData.supplierName);
		},
		isTechnologyFromReseller(){
			return this.supplierOnboardRequestData.technologyFromReseller === 'yes';
		},
		isICRequest(){
			return this.supplierOnboardRequestData.supplierLocated === "US" || this.supplierOnboardRequestData.supplierLocated === "UK" || this.supplierOnboardRequestData.supplierLocated === "Canada";
		}
	},
	methods: {
		...mapActions([
			"createSupplierOnboardRequest",
			"fetchAdskContactInfo",
			"deleteDraftRequestById",
			"populateUserInfo",
		]),
		...mapMutations(["setErrorMessage", "setIsRequestingForOthers","setIsLoading","setErrorDetail"]),
		initializeCountryData() {
			if (this.adminDataListExists()) {
				this.filterCountryOptions();
			} else {
				this.getAllRequiredData();
			}
		},
		toggleNoForGenerativeAI(event) {
			if (CONSTANTS.ONE_INTAKE_RADIO_OPTIONS.some((option) => parseInt(option.id) > 1 && option.text === event.target.value)){
				swal.fire({
					title: `Warning`,
					allowEscapeKey: false,
					allowOutsideClick: false,
					showConfirmButton: true,
					showCancelButton: false,
					confirmButtonText: "SAVE DRAFT",
					cancelButtonText: "Cancel",
					customClass: {
						confirmButton: "btn submit-btn outline-flat-btn swalSubmit",
						cancelButton: "flat-btn primary-blue-btn cancel-btn btn mb-1"
					},
					html: `Please submit the form <a href=${CONSTANTS.GENERATIVE_AI.GENERATIVE_AI_CREATE_RECORD_ARTICLE} target="_blank">here</a> and get approval from that team before submitting this enhancement request form. If you have any questions they can be submitted at <a href=${CONSTANTS.GENERATIVE_AI.GENERATIVE_AI_SLACK_URL} target="_blank">#adsk-generative-ai-tools</a>"`,
				}).then((result) => {
					this.supplierOnboardRequestData.generativeAI = undefined;
					if(result.isConfirmed){
						this.saveSupplierOnboardRequest(true);
					}
				})
			}
		},
		filterCountryOptions() {
			let oneIntakeCheckBoxes = [];
			let oneIntakeCountries = []
			if (this.adminDataList) {
			  let companyCodeList = this.adminDataList.companyCodeList;
			  let countryCodeList = this.adminDataList.countryCodeList;

			  for (let i=0; i< companyCodeList.length; i++) {
				let countryCodeObj = companyCodeList[i];
				let country = countryCodeList.find(obj => obj.value == countryCodeObj.countryCode);

				if (country && countryCodeList) {
					let countryInputObj = this.createCountryObj(countryCodeObj, country);

					if (CONSTANTS.oneIntakeCountryCodeCheckBoxes.includes(countryCodeObj.companyCode)) {
						oneIntakeCheckBoxes.push(countryInputObj);
					} else {
						oneIntakeCountries.push(countryInputObj);
					}
				}
			  }

			  this.countryListOptions = oneIntakeCountries.sort(((a, b) => (a.value > b.value) ? 1 : -1));
			  this.oneIntakeCheckBoxCountries = oneIntakeCheckBoxes.sort(((a, b) => (a.value > b.value) ? 1 : -1));
			}
			this.setIsLoading(false);
		},
		createCountryObj(countryCodeObj, country) {
			let countryData = this.findAdditionalCountryData(countryCodeObj.companyCode);
			return {
				country: country.text,
				threshold: countryData? countryData.threshold: 49999,
				isEligibleForFastTrack: countryData? countryData.isEligibleForFastTrack: false,
				value: this.formatCountryCodeText(false, country, countryCodeObj),
				text: this.formatCountryCodeText(true, country, countryCodeObj),
				costCenter: countryCodeObj.companyCode,
				geo: countryData? countryData.geo: null
			}
		},
		findAdditionalCountryData(countryCode) {
			return CONSTANTS.oneIntakeAllCountryData.find(obj => obj.costCenter == countryCode);
		},
		testForValidInput() {
			var text = document.getElementById("approximateCost");
			text.onkeypress = text.onpaste = this.checkInput;
		},
		checkInput(e) {
			let char =
				e.type == "keypress"
					? String.fromCharCode(e.keyCode || e.which)
					: (e.clipboardData || window.clipboardData).getData("Text");
			if (/[^\d]/gi.test(char)) {
				return false;
			}
		},
		formatCountryCodeText(isCheckBoxText, country, countryCodeObj) {
			// Following previous format of country object value of lower case first word
			// Remove potential commas from SAP response as not to break request drafts
			let countryText = isCheckBoxText? country.text :country.text[0].toLowerCase()+country.text.substring(1)
			return countryText + " - " + countryCodeObj.companyName.replaceAll(",", "") + " - " + countryCodeObj.companyCode
		},
		isCandidateForShortForm() {
			return (
				(this.supplierOnboardRequestData.approximateSpend <= 49999) &&
				this.supplierOnboardRequestData.recommendedByGovernment === false &&
				this.supplierOnboardRequestData.onBehalfOfAutodeskCustomer === false &&
				this.supplierOnboardRequestData.anyRelationshipWithAutodesk === false &&
				this.supplierOnboardRequestData.integrateWithADSKProduct === false &&
				this.supplierOnboardRequestData.personalDataProcessed === false &&
				this.supplierOnboardRequestData.thirdPartyLicenseRequired === false
			);
		},
		convertToLowercase(value) {
			return 	value.trim().toLowerCase();
		},
		async updateUserInfo() {
			this.setIsLoading(true)
			await this.getUserInfo()
			this.setIsLoading(false)
		},
		isEligibleForFastTrack() {
			return (
				this.validatePurchaseType("Services") && 
				this.validateGeneralFormData() && 
				this.validateApproximateSpend() && 
				this.validateNumberOfCountriesSelected() && 
				this.validateCountryForFastTrackAribaEligibility() && 
				this.isSupplierEmployeeCountAboveFive()
			)
		},
		isSupplierNameEntered() {
			return this.isValidString(this.supplierOnboardRequestData.supplierName);
		},
		validatePurchaseType(purchaseType){
			return this.supplierOnboardRequestData.purchaseType === purchaseType
		},
		validateGeneralFormData() {
			return (
				this.supplierOnboardRequestData.masterAgreementExists === "No" &&
				this.supplierOnboardRequestData.deliveredWithInYear &&
				this.supplierOnboardRequestData.serviceType === "None of the above" && this.isSupplierNameEntered() && this.supplierOnboardRequestData.thirdPartyLicenseRequired === false
			);
		},
		validateCountryForFastTrackAribaEligibility() {
			if (this.supplierOnboardRequestData.companyBuyingServices.length === 1){
				return this.supplierOnboardRequestData.companyBuyingServices[0].isEligibleForFastTrack
			}else if(this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length === 1){
				return this.supplierOnboardRequestData.companyBuyingServiceCheckBox[0].isEligibleForFastTrack
			}
		},
		validateNumberOfCountriesSelected() {
			if (this.supplierOnboardRequestData.companyBuyingServices.length > 1) return false
			else if (this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length > 1) return false
			else if (this.supplierOnboardRequestData.companyBuyingServices.length + this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length > 1) return false
			else return true
		},
		validateApproximateSpend() {
			let thresholdRange;
			if (this.supplierOnboardRequestData.companyBuyingServices.length === 1){
				thresholdRange  = this.countryListOptions.find(oneIntakeCountry => this.supplierOnboardRequestData.companyBuyingServices[0].value === oneIntakeCountry.value).threshold;
			}else if(this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length === 1){
				thresholdRange = this.oneIntakeCheckBoxCountries.find(oneIntakeCountry => this.supplierOnboardRequestData.companyBuyingServiceCheckBox[0].value === oneIntakeCountry.value).threshold;
			}
			return (this.supplierOnboardRequestData.companyBuyingServices.length === 1 || this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length === 1) && parseInt(this.supplierOnboardRequestData.approximateSpend) <= parseInt(thresholdRange)
		},
		isEligibleForAriba() {
			//As per current direction , all countries eligible for fast-track are eligible for fast-track too.
			return (
				(this.validatePurchaseType("Goods") || this.validatePurchaseType("Goods&Services")) &&
				this.validateGeneralFormData() && this.validateApproximateSpend() && this.validateNumberOfCountriesSelected() && this.validateCountryForFastTrackAribaEligibility()
			)
		},
		isEligibleForIndependentContractorRedirect() {
			return this.supplierOnboardRequestData.supplierLocated && this.supplierOnboardRequestData.supplierLocated !== "Other";
		},
		updateRequestSubmissionType(draft){
			//This check here is to ensure we send appropriate data to the API if the submission is a fastTrack/Ariba and not a draft, if draft/Normal-Submission we would send SUPPLIER_CENTRAL_VALUE.
			if (this.isEligibleForIndependentContractorRedirect() && !draft){
				this.isIndependentContractor = true;
				this.supplierCountry = this.supplierOnboardRequestData.supplierLocated;
				this.supplierOnboardRequestData.requestSubmissionType = CONSTANTS.IC_VALUE
			}
			else if (this.isEligibleForFastTrack() && !draft && this.isCandidateForShortForm()){
				this.isFastTrackEligible = true;
				this.supplierOnboardRequestData.requestSubmissionType = CONSTANTS.FAST_TRACK_VALUE
			}else if (this.isEligibleForAriba() && !draft && this.isCandidateForShortForm()){
				this.isAribaEligible = true;
				this.supplierOnboardRequestData.requestSubmissionType = CONSTANTS.ARIBA_VALUE
			}else {
				this.supplierOnboardRequestData.requestSubmissionType = CONSTANTS.SUPPLIER_CENTRAL_VALUE
			}
		},
		setProductName(){
			if(this.supplierOnboardRequestData.supplierName && !this.supplierOnboardRequestData.productName){
                this.supplierOnboardRequestData.productName= this.supplierOnboardRequestData.supplierName + " Service";
				this.supplierOnboardRequestData.serviceProduct = true;
            }
		},
		saveSupplierOnboardRequest(draft) {
			/*
			* delete case metadata which is fetched when a returned request is pulled in
			* below data is not needed to be sent to system as a new case is created.
			*/
			delete this.supplierOnboardRequestData.requestedByFullName;
			delete this.supplierOnboardRequestData.requestedForFullName;
			delete this.supplierOnboardRequestData.updatedOn;
			delete this.supplierOnboardRequestData.createdOn;
			delete this.supplierOnboardRequestData.caseNumber;
			delete this.supplierOnboardRequestData.viewCaseUrl;
			delete this.supplierOnboardRequestData.status;
			delete this.supplierOnboardRequestData.requestStatus;
			delete this.supplierOnboardRequestData.caseId;
			delete this.supplierOnboardRequestData.isRequestedForResubmission;
			delete this.supplierOnboardRequestData.existingSupplier;

			//update productName with supplierName if its empty.
			if(!draft){
				this.setProductName();
            }
			//This check here is to ensure that if in any way possible US is not found in the dropdown, we then delete the diverseSupplierConsidered field
			if (!this.isCountryUS){
				delete this.supplierOnboardRequestData.diverseSupplierConsidered
			}
			//This check here ensures we are pushing watchers to the api, if the watchers array has length > 0 , the add the items in the watcherUserIds seperated by a ',', else not.
			if (this.watchers && this.watchers.length > 0){
				this.supplierOnboardRequestData.watcherUserIds = this.watchers.map(user => user.id).join(",");
			}else if (this.watchers && this.watchers.length === 0){
				delete this.supplierOnboardRequestData.watcherUserIds;
			}

			//This call is to set requestSubmissionType based on Ariba/FastTrack Workflow
			this.updateRequestSubmissionType(draft)

			//This call ensures that we extract countries from the dropdown as well as the checkbox in the proper format before sending it to the API.
			this.modifyCompanyBuyingServices();

			this.createSupplierOnboardRequest({
				data: this.supplierOnboardRequestData,
				isDraft: draft,
			}).finally(() => {
				if (!this.errorMessage) {
					if (draft) {
						this.showMessage(true);
					} else {
						this.showMessage(false);
					}
				} else {
					if(process.env.VUE_APP_ENVIRONMENT === 'PRD')
					{
						this.createErrorIncident(this.errorDetail, this.errorDetail, CONSTANTS.ERROR_PAYLOAD_VALUES_FOR_ONE_INTAKE);
					}
					this.showFailureNotification(true);
				}
			});

		},
		modifyCompanyBuyingServices(){
			//This check here ensures that we see through both dropdown and checkbox values and combine them into a local "companyBuyingServicesCombined" property and thereafter mapping through it and getting the countries text only from to send to the API.
			if (this.supplierOnboardRequestData.companyBuyingServices && this.supplierOnboardRequestData.companyBuyingServices.length > 0){
				this.companyBuyingServicesCombined = [...this.supplierOnboardRequestData.companyBuyingServices];
			}
			if (this.supplierOnboardRequestData.companyBuyingServiceCheckBox && this.supplierOnboardRequestData.companyBuyingServiceCheckBox.length > 0){
				this.companyBuyingServicesCombined = [...this.companyBuyingServicesCombined,...this.supplierOnboardRequestData.companyBuyingServiceCheckBox]
			}

			//Final assignment before we send it to api after combining from checkbox and dropdown for Q6 from GeneralInformation.vue
			this.supplierOnboardRequestData.companyBuyingServices = this.companyBuyingServicesCombined.map(item => item.text).join(",");

			if (this.supplierOnboardRequestData.companyBuyingServices.length === 0){
				delete this.supplierOnboardRequestData.companyBuyingServices;
			}
			//Make sure to delete these property before we send it to API, because API does only accepts "companyBuyingServices"
			delete this.supplierOnboardRequestData.companyBuyingServiceCheckBox;
		},
		showFailureNotification(isOneIntake = false) {
			swal
				.fire({
					title: `Error`,
					html: isOneIntake ? CONSTANTS.ONE_INTAKE_ERROR_MESSAGE : CONSTANTS.ERROR_MESSAGE,
					confirmButtonText: "Ok",
					focusConfirm: false,
					customClass: {
						confirmButton: "flat-btn primary-blue-btn btn",
					},
					buttonsStyling: false,
				})
				.then((result) => {
					if (result.isConfirmed) {
						this.setErrorDetail(null);
						this.setErrorMessage(null);
						this.$router.replace("/");
					}
				});
		},
		async getUserInfo() {
			await this.populateUserInfo({
				userId: this.currentUser.userName,
				requestedBy: true,
			})

			if (
				this.supplierOnboardRequestData.requestedFor !== undefined &&
				this.supplierOnboardRequestData.requestedFor !== ""
			) {
				this.setIsRequestingForOthers(true);
				await this.populateUserInfo({
					userId: this.supplierOnboardRequestData.requestedFor,
					requestedBy: false,
				});
			}
			this.setCurrentTab("GeneralInformation");
			this.activeTabIndex = 0;
			this.currentComponent = this.tabItems[0].component;
		},
		showMessage(draft) {
			if (draft) {
				swal
					.fire({
						title: `Draft saved`,
						html: `Drafts can be viewed on My supplier requests tab in Supplier central`,
						showCancelButton: true,
						confirmButtonText: "Supplier requests",
						allowEscapeKey:false,
						allowOutsideClick:false,
						cancelButtonText: "Continue Draft",
						focusConfirm: false,
						customClass: {
							confirmButton: "flat-btn primary-blue-btn btn mb-3",
							cancelButton: "flat-btn gray-btn cancel-btn btn mb-3",
						},
						buttonsStyling: false,
					})
					.then((result) => {
						if (result.isConfirmed) {
							this.$hhMixpanel.trackEvent("Vendor One-Intake Draft Saved");
							this.$router.replace({ name: "StatusDashboard" });
						} else {
							if (this.$route.meta.tab !== "DraftIntakeForm") {
								this.$router.replace({
									name: "DraftIntakeForm",
									params: { id: this.draftId },
								});
							} else {
								/* Since we delete requestedByFullName before sending it to api, we need to re-populate it if user chooses to 'Continue draft'
								 *  Below logic captures that condition and populates requestedByFullName and requestedForFullName */
								if (
									this.supplierOnboardRequestData.requestedByFullName ===
										undefined ||
									this.supplierOnboardRequestData.requestedByFullName.length ===
										0
								) {
									this.updateUserInfo();
								}
							}
						}
					});
			} else {
				this.validateAndShowModal();
			}
		},
		validateAndShowModal() {
			if (this.isIndependentContractor) {
				this.$emit("close");
				this.showIndependentContractorSuccessMessage();
			}
			else if(this.isFastTrackEligible) {
				this.$emit("close");
				this.showFastTrackEligibleMessage();
			} else if (this.isAribaEligible) {
				this.$emit("close");
				this.showAribaRerouteMessage();
			} else {
				let userMessage = "";
				const currentUrl = window.location.href;
				let statusDashboardUrl = currentUrl.includes(CONSTANTS.LOCALHOST_URL)
					? "http://"+CONSTANTS.LOCALHOST_URL +
					  this.$router.options.base +
					  "/status-dashboard"
					: CONSTANTS.EH_URL + this.$router.options.base + "/status-dashboard";
				if (this.caseDetails.viewCaseUrl && this.caseDetails.caseNumber) {
					let url = this.generateEmployeeHubCaseURL() + this.caseDetails.caseNumber
					const baseMessage = `Created <a href=${url} target="_blank">${this.caseDetails.caseNumber}</a> - track using <a href="${statusDashboardUrl}">My supplier requests tab</a> or <a href=${url} target="_blank">click here to view</a> `;
					//showing an additional help-text if supplier is AMC bridge to guide on re-direction
					userMessage = this.isSOWRequest ? `${baseMessage} <br><br><i>On clicking OK you'll be redirected to SOW form for Supplier - ${this.supplierOnboardRequestData.supplierName}<i>` : `${baseMessage}`;
				}else {
					userMessage = `Track using <a href="${statusDashboardUrl}">My supplier requests tab</a>`;
				}
				swal
					.fire({
						title: `Submitted!`,
						allowOutsideClick: false,
						allowEscapeKey: false,
						html: userMessage,
						showConfirmButton: true,
						focusConfirm: false,
						customClass: {
							confirmButton: "flat-btn primary-blue-btn btn mb-3",
						},
						buttonsStyling: false,
					})
					.then((result) => {
						if (result.isConfirmed) {
							this.$hhMixpanel.trackEvent("Vendor One-Intake Form Submitted");
							this.$router.replace("/");
							if(this.isSOWRequest){
								//redirect to SOW form on a new tab
								window.open(CONSTANTS.AMC_SOW_URL, '_blank');
							}
						}
					});
			}
		},
		redirectToProcurementDocumentsForIC(){
			const country = this.supplierCountry;
			if(!country) return;
			let redirectURL=this.independentContractorRedirectLink[country];
			this.supplierCountry = null
			return redirectURL
		},

		showIndependentContractorSuccessMessage() {
			const redirectURL = this.redirectToProcurementDocumentsForIC();
			let userMessage=""
			const currentUrl = window.location.href;
			let statusDashboardUrl = currentUrl.includes(CONSTANTS.LOCALHOST_URL)
					? "http://"+CONSTANTS.LOCALHOST_URL +
					  this.$router.options.base +
					  "/status-dashboard"
					: CONSTANTS.EH_URL + this.$router.options.base + "/status-dashboard";
			let showConfirmButton = !!redirectURL;
			if(redirectURL){
				userMessage = `
					Thank you for beginning the privacy screening process. In order to engage an Independent Contractor, you must also complete the vetting and contracting process outside of Supplier Central. You will be redirected to country specific instructions. 
				`
			}
			else{
				userMessage = `Track using <a href="${statusDashboardUrl}">My supplier requests tab</a>`;
			}
			swal
				.fire({
					title: `Submitted!`,
					html: userMessage,
					allowEscapeKey: false,
					allowOutsideClick: false,
					focusConfirm: false,
					showConfirmButton: showConfirmButton,
					showCancelButton: false,
					buttonsStyling: false,
					confirmButtonText: "Proceed to final instructions",
					customClass: {
						confirmButton: "flat-btn primary-blue-btn btn"
					},
				})
				.then((result) => {
					if (result.isConfirmed) {
						window.location.href = redirectURL
					}
				});
			    this.isIndependentContractor=false

		},
		showFastTrackEligibleMessage() {

			let footerMessage = this.generateFooterMessage()

			swal
				.fire({
					title: `Success`,
					html: `<div>You qualify for fast track process. Please launch the fast track form to complete the supplier engagement process. <br> <br> <span style="font-size:14px; color: #606060; font-style: italic ">Please note that if fast track requests  permission for Sharepoint and O365 users, please select "Fix connection" and "Allow" the permissions to proceed submitting the fast track form.</span><div`,
					footer: footerMessage,
					allowEscapeKey: false,
					allowOutsideClick: false,
					focusConfirm: false,
					showCancelButton: false,
					confirmButtonText: "Launch Fast Track Form",
					cancelButtonText: "Cancel",
					customClass: {
						confirmButton: "flat-btn primary-blue-btn btn",
						cancelButton: "flat-btn gray-btn cancel-btn btn",
					},
					reverseButtons: true,
					buttonsStyling: false,
				})
				.then((result) => {
					if (result.isConfirmed) {
						let fastTrackUrl = this.createUrl();
						this.$hhMixpanel.trackEvent("Vendor One-Intake Fasttrack success");
						window.open(fastTrackUrl);
						if (this.draftId.length > 0) {
							this.deleteDraftRequestById(this.draftId).then(() => {
								this.navigateToHome();
							});
						} else {
							this.navigateToHome();
						}
					}
					this.isFastTrackEligible = false;
				});
		},
		showAribaRerouteMessage() {
			let footerMessage = this.generateFooterMessage()

			swal
				.fire({
					title: `You’re now ready to complete your purchase`,
					html: `Use your corporate card to pay if your purchase is 
							<br><br>(1) less than $5,000 USD-equivalent, and 
							<br>(2) not for laptops, desktops, servers, mobile computing devices, professional services, or gift cards.
							<br><br> Contact the <a href="${CONSTANTS.CORPORATE_TEAM_SLACK_URL}" target="_blank">Corporate Card team</a> 
							with questions. <br>For all other purchases, go to Ariba to complete your non-catalog order. 
							<br><br>Contact the <a href="${CONSTANTS.PROCUREMENT_TEAM_SLACK_URL}" target="_blank">Procurement team</a> with questions.`,
					footer: footerMessage,
					allowEscapeKey: false,
					padding: "1.7rem",
					width: "35rem",
					allowOutsideClick: false,
					focusConfirm: false,
					showCancelButton: false,
					confirmButtonText: "Launch Ariba",
					cancelButtonText: "Cancel",
					customClass: {
						confirmButton: "flat-btn primary-blue-btn btn",
						cancelButton: "flat-btn gray-btn cancel-btn btn",
					},
					reverseButtons: true,
					buttonsStyling: false,
				})
				.then((result) => {
					if (result.isConfirmed) {
						let aribaRerouteURL = CONSTANTS.ARIBA_REROUTE_URL;
						this.$hhMixpanel.trackEvent(
							"Vendor One-Intake user is routed to Ariba"
						);
						window.open(aribaRerouteURL);
						if (this.draftId.length > 0) {
							this.deleteDraftRequestById(this.draftId).then(() => {
								this.navigateToHome();
							});
						} else {
							this.navigateToHome();
						}
					}else{
						this.navigateToHome()
					}
					this.isAribaEligible = false;
				});
		},
		navigateToHome() {
			if (window.history.length > 2) {
				this.$router.go(-1);
			} else {
				this.$router.push("/").then(() => {});
			}
		},
		generateFooterMessage() {
			let footerMessage = ''
			if (this.caseDetails.viewCaseUrl && this.caseDetails.caseNumber) {
				let url = this.generateEmployeeHubCaseURL()+this.caseDetails.caseNumber
				footerMessage = `<div class="d-inline-block">A Supplier Central case <a href=${url} target="_blank">${this.caseDetails.caseNumber}</a> has been created in case any further assistance is needed with this request.</div>`
			}
			return footerMessage
		},
		generateEmployeeHubCaseURL(){
			return CONSTANTS.EH_URL+'/apps/supplier-central/status-dashboard/status/'
		},
		createUrl() {
			let url = `?`;
			let selectedCountry = this.countryListOptions.find(item => item.text === this.supplierOnboardRequestData.companyBuyingServices)
			if (!selectedCountry){
				selectedCountry = this.oneIntakeCheckBoxCountries.find(item => item.text === this.supplierOnboardRequestData.companyBuyingServices)
			}
			url += `&Country=${selectedCountry.country}`;
			url += this.isValidString(this.supplierOnboardRequestData.supplierName)
				? `&SupplierCompanyName=${this.supplierOnboardRequestData.supplierName}`
				: "";
			url += this.isValidString(
				this.supplierOnboardRequestData.supplierContactName
			)
				? `&SupplierContactName=${this.supplierOnboardRequestData.supplierContactName}`
				: "";
			url += this.isValidString(
				this.supplierOnboardRequestData.supplierContactEmail
			)
				? `&SupplierEmail=${this.supplierOnboardRequestData.supplierContactEmail}`
				: "";
			url += this.isValidString(this.adskContactInfo.fullName)
				? `&AutodeskContactName=${this.adskContactInfo.fullName}`
				: "";
			url += this.isValidString(this.adskContactInfo.emailAddress)
				? `&AutodeskEmail=${this.adskContactInfo.emailAddress}`
				: "";
			url += this.isValidString(this.adskContactInfo.phoneNumber)
				? `&AutodeskPhoneNumber=${this.adskContactInfo.phoneNumber}`
				: "";

			/* remove the first ampersand & form query params */
			url = url.slice(0, 1) + url.slice(2);
			url = encodeURI(CONSTANTS.PTP_REDIRECT_URL + url);

			return url;
		},
		isValidString(str) {
			return str !== "" && str !== undefined && str.length > 0;
		},
		disableAutofill(id) {
			let element = document.getElementById(id)
			if(element) {
				element.autocomplete = 'eh-autofill-off'
			}
		},
		getFilteredProducts(products) {
			let filteredProducts = JSON.parse(JSON.stringify(products));
			filteredProducts.forEach((product) => {
				if (product.engagementUrl) {
					if (
						product.engagementUrl.toLowerCase().includes("ariba") ||
						product.engagementUrl
							.toLowerCase()
							.includes(CONSTANTS.EH_PURCHASE_INSTRUCTIONS_URL)
					) {
						product["nextSteps"] = CONSTANTS.PURCHASING_INSTRUCTIONS_NEXT_STEPS;
					} else if (
						product.engagementUrl &&
						product.engagementUrl.toLowerCase().includes("wolkenservicedesk")
					) {
						product["nextSteps"] = CONSTANTS.SOFTWARE_PURCHASE_REQUEST_FORM;
					}else if(
						(CONSTANTS.CLICK_HERE_FOR_ACCESS_APP_REGEX.test(product.name)
					)) {
						product["nextSteps"] = CONSTANTS.CLICK_HERE_FOR_ACCESS;
					}
					else if(CONSTANTS.CLICK_HERE_TO_DOWNLOAD_REGEX.test(product.name)){
						product["nextSteps"] = CONSTANTS.CLICK_HERE_TO_DOWNLOAD;
					}

					//  EXPAPORTAL-57 : This is a temporary fix, will be removed later

					if (CONSTANTS.SSO_LOGIN_APP_REGEX.test(product.name) && !product.engagementUrl.toLowerCase().includes("wolkenservicedesk")){
						product.engagementUrl = filter.updateUrlWithHttp(
							product.engagementUrl
						);
						product["nextSteps"] = CONSTANTS.SSO_LOGIN_TEXT;
						product["isExternalLink"] = true;
						product["isPurchaseWithCard"]  = false
					}
				} else {
					product["nextSteps"] = CONSTANTS.ENGAGE_WITH_SUPPLIER;
				}
				if (
					product.status.toLowerCase() ===
					CONSTANTS.STALEMATE_STATUS.toLowerCase()
				) {
					product.status = "Unable to reach agreement";
				}
				if(product.status.toLowerCase()==="compliant-no-data"){
					product.status= CONSTANTS.COMPLAINT_NO_PERSONAL_DATA_STATUS;
					product['displayText'] = "Instructions";
				}
			});
			return filteredProducts;
		},
		getTextValue(list, value) {
			let returnValue = ''
			if(value) {
				returnValue =  list.find(item => item.value === value).text
			}
			return returnValue.toString()
		},
		goToIndependentContractorArticle() {
			swal
				.fire({
					title: `Thank you`,
					html: `Based on your responses, the supplier may qualify as an independent contractor (IC) and require an IC screening. Please visit the Independent Contractor page and follow the engagement process steps.`,
					footer:
						'<span class="text-danger">Going to the IC article will exit the current process</span>',
					allowEscapeKey: false,
					allowOutsideClick: false,
					focusConfirm: false,
					showCancelButton: true,
					confirmButtonText: "Confirm",
					cancelButtonText: "Cancel",
					customClass: {
						confirmButton: "flat-btn primary-blue-btn btn",
						cancelButton: "flat-btn gray-btn cancel-btn btn",
					},
					reverseButtons: true,
					buttonsStyling: false,
				})
				.then((result) => {
					if (result.isConfirmed) {
						window.location.href =
							process.env.VUE_APP_INDEPENDENT_CONTRACTOR_ARTICLE;
					}
				});
		},
		createErrorIncident(errorDescription, eventDetail, errorPayloadValuesMap ){

			let errorPayloadFields = CONSTANTS.ERROR_PAYLOAD_FIELD_NAMES;
			let errorPayload = {}

			Object.keys(errorPayloadFields).forEach((field) => {
				if (errorPayloadValuesMap[field]){
					errorPayload[errorPayloadFields[field]] = errorPayloadValuesMap[field]
				}
				else if(field == CONSTANTS.SHORT_DESCRIPTION){
					errorPayload[errorPayloadFields[field]] = errorDescription
				}
				else if(field == CONSTANTS.EVENT_DETAIL){
					errorPayload[errorPayloadFields[field]] = eventDetail
				}
			})

			api.createErrorIncident(errorPayload).then((response) => {
				console.log("Error Incident Created", response);
			}).catch((error) => {
				console.log("Error creating incident", error);
			});
		
			this.$hhMixpanel.trackEvent("Vendor One-Intake Error Incident Created");

		},
		isSupplierEmployeeCountAboveFive(){
			return !(this.supplierOnboardRequestData.supplierEmployeeCountBelowFive)
		}
	},
};
